import React from 'react';
import { Route } from 'react-router';
import Layout from './components/Layout';
import Home from './components/Home';
import Page1Email from './components/Page1Email';
import PengkinianData  from './components/PengkinianData/PengkinianData';
import PengkinianDataSucceed from './components/PengkinianData/PengkinianDataSucceed';
import RegisterSucceed from './components/RegisterSucceed';
import Page2ChooseBank from './components/Page2ChooseBank';
import Page4Docoument from './components/Page4Document';
import PhotoForm from './components/PhotoForm';
//import Jabatan from './components/Jabatan';
//import FrmRegister from './components/FrmRegister';
//import Counter from './components/Counter';
//import FetchData from './components/FetchData';

// var Globalize = require("globalize");
// Globalize.load( require( "cldr-data" ).entireMainFor( "en", "en" ) );
// Globalize.locale('en');
export default () => (
    <Layout>
        <Route exact path='/' component={Home} />
        {/*<Route exact path='/' component={Page1Email} />*/}
        <Route path='/bank' component={Page2ChooseBank} />
        <Route exact path='/register' component={Home} />
        <Route path='/register/document' component={Page4Docoument} />
        <Route path='/register/photo' component={PhotoForm} />
        <Route path='/pengkinian-data' component={PengkinianData} />
        <Route path='/pengkinian-data-succeed/:ref' component={PengkinianDataSucceed} />
        <Route path='/register-succeed' component={RegisterSucceed} />

        {/*<Route path='/counter' component={Counter} />        */}
        {/*<Route path='/jabatan' component={Jabatan} />      */}
        {/*<Route path='/education' component={FrmRegister} />*/}
        {/*<Route path='/fetch-data/:startDateIndex?' component={FetchData} />*/}
    </Layout>
);



// WEBPACK FOOTER //
// ./src/App.js